export default __webpack_public_path__ + "static/media/mo.5cb2ef8c.png";